// @ts-nocheck
export const localeCodes =  [
  "ru"
]
export const localeLoaders = {
  ru: []
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "ru",
    domains: [
      "https://dtmskin.com",
      "https://en.dtmskin.com"
    ],
    defaultForDomains: [
      "ru"
    ],
    _hreflang: "ru",
    _sitemap: "ru",
    language: undefined
  }
]
/** client **/

/** client-end **/